<template>
  <div
    class="min-h-full px-4 py-16 sm:px-6 sm:py-32 md:grid md:place-items-center lg:px-8"
  >
    <div class="max-w-4xl mx-auto">
      <section class="sm:flex">
        <p class="text-4xl font-extrabold text-error sm:text-5xl">
          {{ error.statusCode }}
        </p>
        <div class="sm:ml-6">
          <div class="sm:border-l sm:border-gray-200 sm:pl-6">
            <h1 class="text-4xl font-extrabold">
              {{ errorMessage.message }}
            </h1>

            <p v-if="errorMessage.sub" class="mt-2 text-base text-toned">
              {{ errorMessage.sub }}
            </p>
          </div>

          <div
            class="flex mt-10 space-x-3 sm:border-l sm:border-transparent sm:pl-6"
          >
            <template
              v-if="error.statusMessage === CustomErrorCodes.OFFER_NOT_FOUND"
            >
              <VButton
                :size="Size.sm"
                @click="$emit('redirect', '/request-quote')"
              >
                {{ $t('errorMessage.funnelButton') }}
              </VButton>
            </template>

            <template v-else>
              <VButton :size="Size.sm" @click="$emit('redirect', '/')">
                {{ $t('errorMessage.homeButton') }}
              </VButton>

              <VButton
                :size="Size.sm"
                :variant="Variant.secondary"
                @click="$emit('redirect', '/kontact')"
              >
                {{ $t('errorMessage.contactButton') }}
              </VButton>
            </template>
          </div>
        </div>
      </section>

      <div v-if="isTraceLogEnabled" class="mt-10 text-left">
        <p class="text-2xl">
          {{ error.statusCode + ' ' + error.statusMessage }}
        </p>

        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-if="error.stack" v-html="sanitizeHtml(error.stack)" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import sanitizeHtml from 'sanitize-html'
import { CustomErrorCodes, Size, Variant } from '@/types/enums'
import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
  isTraceLogEnabled?: boolean
}>()

defineEmits<{
  (e: 'redirect', path: string): void
}>()

const { t } = useI18n()

const errorMessage = computed(() => {
  if (props.error.statusCode === 404) {
    if (props.error.statusMessage === CustomErrorCodes.OFFER_NOT_FOUND) {
      return {
        message: t('errorMessage.offerNotFound.message'),
        sub: t('errorMessage.offerNotFound.sub'),
      }
    } else {
      return { message: t('errorMessage.notFound'), sub: '' }
    }
  } else {
    return {
      message: t('errorMessage.unexpectedError.message'),
      sub: t('errorMessage.unexpectedError.sub'),
    }
  }
})
</script>
